exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports
exports.i(require("-!../../node_modules/css-loader/index.js?minimize!../../node_modules/vue-slider-component/theme/default.css"), "");

// module
exports.push([module.id, ".attribute-number-value{color:#4baf4d}.slider-placeholder{margin:3px 0 3px 15px}.no-border{border:none!important;box-shadow:none!important}.attribute-placeholder{min-height:100px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-rewriter.js?id=data-v-c6c935d8!./~/sass-loader!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/AttributesComponent.vue
// module id = 934
// module chunks = 2